// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/offerfit/:app_group_id/use_cases/:use_case_id/campaign_data" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { offerfitAppGroupIdUseCasesUseCaseIdCampaignData } from "./constants";
import type { OfferfitUseCaseCampaignDataResult } from "./types";

export const getOfferfitAppGroupIdUseCasesUseCaseIdCampaignData = reactQueryFetcherAdapter(
  offerfitAppGroupIdUseCasesUseCaseIdCampaignData,
  (signal: AbortSignal, appGroupId: string, useCaseId: string): Promise<OfferfitUseCaseCampaignDataResult> => {
    return fetch(
      `/offerfit/${appGroupId}/use_cases/${useCaseId}/campaign_data`,
      "GET",
      {},
      { signal },
      { propagateFetchRequestError: false }
    );
  }
);
